import { useState, useEffect } from "react";

const useMapboxAuth = () => {
    const [mapboxAccessToken, setMapboxAccessToken] = useState("");

    useEffect(() => {
        (async function () {
            console.debug("Calling /api/mapbox-access-token");
            const result = await (
                await fetch(`/api/mapbox-access-token`)
            ).json();
            setMapboxAccessToken(result.mapboxAccessToken);
        })();
    }, []);

    return {
        mapboxAccessToken: mapboxAccessToken,
    };
};

export default useMapboxAuth;
